import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'interfaces';
import { initialState } from './slice';

const selectDomain = (state: RootState) => state['feature/base/core'] || initialState;

export const selectAllState = createSelector([selectDomain], (state) => state);
export const selectTheme = createSelector([selectDomain], (state) => state.theme);
export const selectEnterprise = createSelector([selectDomain], (state) => state.enterprise);
export const selectCategories = createSelector(
  [selectDomain],
  (state) => state.enterprise.categories,
);
export const selectExchangeRates = createSelector(
  [selectDomain],
  (state) => state.enterprise.exchange_rates,
);

export const selectAlert = createSelector([selectDomain], (state) => state.alert);
export const selectSnack = createSelector([selectDomain], (state) => state.snack);
// eslint-disable-next-line max-len
export const selectRelatedSkills = createSelector([selectDomain], (state) => state.enterprise.skills);
export const selectLoading = createSelector([selectDomain], (state) => state.loading);
export const selectNotifications = createSelector([selectDomain], (state) => state.notifications);
export const selectWindowIsDisabled = createSelector(
  [selectDomain],
  (state) => state.windowIsDisabled,
);
